import { every, findIndex, get, isNull, some, filter, includes } from "lodash"
import { formatBetaInstrumentTooltip } from "./contributors"

export const COMPOSITION = {
  GMV: "Gross Market Value",
  REF_EQUITY: "Reference Equity",
  POSITIONS: "Positions",
  CONCENTRATION: "Concentration",
  MODEL_COVERAGE: "Model Coverage",
  MARKET_CAP: " Market Capitalization",
}

const hasUploadedEquity = (collection) => {
  return some(collection, (item) => item && !isNull(get(item, "summary.equity")))
}

export const filterCompareTable = (items, data, rowsToFilter) => {
  const filtered = [...items]
  const toRemove = []
  every(rowsToFilter, ({ key: row, value }) => {
    // Dont filter out ref equity if its been uploaded
    if (COMPOSITION.REF_EQUITY && hasUploadedEquity(data)) { return true }
    const index = findIndex(items, ({ label }) => label === row)
    if (index !== -1) {
      const { fn: getItemValue } = items[index]
      // Check if all row values are empty ("--"). The prop fn is the method to get the value from a data item
      // and if the row is empty, we remove it from display
      if (getItemValue && !some(data, (item) => !isNull(item) && getItemValue(item) !== value)) {
        toRemove.push(index)
      }
    }
    return true
  })
  return filter(filtered, (o, index) => !includes(toRemove, index))
}

export const getBetaColumnsAndTooltips = (modelName, betaInstrument) => {
  const formattedBetaInstrumentTooltip = formatBetaInstrumentTooltip(betaInstrument)
  return {
    historical: {
      category: "beta",
      label: "Historical",
      tooltip: [`Historical Beta values are provided by the ${modelName} model.`],
    },
    predicted: {
      category: "beta",
      label: "Predicted",
      tooltip: [`Predicted Beta values are provided by the ${modelName} model.`],
    },
    ...(betaInstrument && { custom: {
      category: "beta",
      label: `Custom - ${get(formattedBetaInstrumentTooltip, "dynamicBetaId")}`,
      tooltip: formattedBetaInstrumentTooltip,
    } }),
  }
}
